import { render, staticRenderFns } from "./tmall-data-change.vue?vue&type=template&id=3d8a4765&scoped=true"
import script from "./tmall-data-change.vue?vue&type=script&lang=ts"
export * from "./tmall-data-change.vue?vue&type=script&lang=ts"
import style0 from "./tmall-data-change.vue?vue&type=style&index=0&id=3d8a4765&prod&lang=scss&scoped=true"
import style1 from "./tmall-data-change.vue?vue&type=style&index=1&id=3d8a4765&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8a4765",
  null
  
)

export default component.exports